import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { handlePending, handleRejected } from '../../common/extra-reducers/commonExtraReducers';
import { conditionalItemDirectHireAPI, conditionalItemDirectHireSaveAPI, conditionalItemLocalListAPI, conditionalItemLocalSaveAPI, conditionalItemOverseasListAPI, fetchFixedItemListAPI, fetchFixedItemListByTypeAPI, fetchPromotionListAPI, fetchWorkerPromotionListAPI, fixedItemSaveAPI, invoiceConditionalItemOverseasSaveAPI, savePromotionAPI, saveWorkerPromotionAPI } from '../../../../services/settings/priceList';
import { handleConditionalIteLocalSave, handleConditionalItemDirectHire, handleConditionalItemDirectHireSave, handleConditionalItemLocalList, handleConditionalItemOverseasList, handleConditionalItemSaveFulfilled, handleFetchPromotionList, handleFetchWorkerPromotionList, handleFixedItemSaveFulfilled, handleFixedItemsListByTypeFulfilled, handleFixedItemsListFulfilled, handleSavePromotionFulfilled, handleSaveWorkerPromotionFulfilled } from './priceListExtraReducers';

export const fetchPromotionList = createAsyncThunk('priceList/fetchPromotionList', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await fetchPromotionListAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const fetchWorkerPromotionList = createAsyncThunk('priceList/fetchWorkerPromotionList', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await fetchWorkerPromotionListAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const savePromotion = createAsyncThunk('priceList/savePromotion', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await savePromotionAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const saveWorkerPromotion = createAsyncThunk('priceList/saveWorkerPromotion', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await saveWorkerPromotionAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const conditionalItemDirectHire = createAsyncThunk('priceList/conditionalItemDirectHire', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await conditionalItemDirectHireAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const conditionalItemDirectHireSave = createAsyncThunk('priceList/conditionalItemDirectHireSave', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await conditionalItemDirectHireSaveAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const conditionalItemLocalSave = createAsyncThunk('priceList/conditionalItemLocalSave', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await conditionalItemLocalSaveAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const conditionalItemLocalList = createAsyncThunk('priceList/conditionalItemLocalList', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await conditionalItemLocalListAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const conditionalItemOverseasList = createAsyncThunk('priceList/conditionalItemOverseasList', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await conditionalItemOverseasListAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const fetchFixedItemList = createAsyncThunk('priceList/fetchFixedItemList', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await fetchFixedItemListAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const fetchFixedItemListByType = createAsyncThunk('priceList/fetchFixedItemListByType', async (type, { rejectWithValue }) => {
  try {
    const response = await fetchFixedItemListByTypeAPI(type); 
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const fixedItemSave = createAsyncThunk('priceList/fixedItemSave', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await fixedItemSaveAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const conditionalItemOverseasSave = createAsyncThunk('priceList/conditionalItemOverseasSave', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await invoiceConditionalItemOverseasSaveAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

const priceListSlice = createSlice({
  name: 'priceList',
  initialState: {
    promotionList: {},
    fixedItemsListByType: [],
    workerPromotionList: {}, // New state for worker promotions
    conditionItemOverseasList: [],
    conditionItemLocalList: [],
    conditionItemDirectHire: [],
    fixedItems: [],
    status: 'success',
    error: null,
    currentPagePromotion: 1,
    perPagePromotion: 1,
    totalPagesPromotion: 0,
    totalPromotions: 0,
    lastUpdatedPromotion: '',
    message: null,
    currentPageWorkerPromotion: 1, // New state for current page of worker promotions
    perPageWorkerPromotion: 1, // New state for items per page of worker promotions
    totalPagesWorkerPromotion: 0, // New state for total pages of worker promotions
    totalWorkerPromotions: 0, // New state for total worker promotions
    lastUpdatedWorkerPromotion: '', // New state for last updated time for worker promotions
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPromotionList.pending, handlePending)
      .addCase(fetchPromotionList.fulfilled, handleFetchPromotionList)
      .addCase(fetchPromotionList.rejected, handleRejected)
      .addCase(savePromotion.pending, handlePending)
      .addCase(savePromotion.fulfilled, handleSavePromotionFulfilled)
      .addCase(savePromotion.rejected, handleRejected)
      .addCase(fetchWorkerPromotionList.pending, handlePending)
      .addCase(fetchWorkerPromotionList.fulfilled, handleFetchWorkerPromotionList)
      .addCase(fetchWorkerPromotionList.rejected, handleRejected)
      .addCase(saveWorkerPromotion.pending, handlePending)
      .addCase(saveWorkerPromotion.fulfilled, handleSaveWorkerPromotionFulfilled)
      .addCase(saveWorkerPromotion.rejected, handleRejected)

      .addCase(conditionalItemDirectHire.pending, handlePending)
      .addCase(conditionalItemDirectHire.fulfilled, handleConditionalItemDirectHire)
      .addCase(conditionalItemDirectHire.rejected, handleRejected)
      .addCase(conditionalItemDirectHireSave.pending, handlePending)
      .addCase(conditionalItemDirectHireSave.fulfilled, handleConditionalItemDirectHireSave)
      .addCase(conditionalItemDirectHireSave.rejected, handleRejected)

      .addCase(conditionalItemLocalList.pending, handlePending)
      .addCase(conditionalItemLocalList.fulfilled, handleConditionalItemLocalList)
      .addCase(conditionalItemLocalList.rejected, handleRejected)
      .addCase(conditionalItemLocalSave.pending, handlePending)
      .addCase(conditionalItemLocalSave.fulfilled, handleConditionalIteLocalSave)
      .addCase(conditionalItemLocalSave.rejected, handleRejected)

      .addCase(conditionalItemOverseasList.pending, handlePending)
      .addCase(conditionalItemOverseasList.fulfilled, handleConditionalItemOverseasList)
      .addCase(conditionalItemOverseasList.rejected, handleRejected)

      .addCase(fetchFixedItemList.pending, handlePending)
      .addCase(fetchFixedItemList.fulfilled, handleFixedItemsListFulfilled)
      .addCase(fetchFixedItemList.rejected, handleRejected)

      .addCase(fetchFixedItemListByType.pending, handlePending)
      .addCase(fetchFixedItemListByType.fulfilled, handleFixedItemsListByTypeFulfilled)
      .addCase(fetchFixedItemListByType.rejected, handleRejected)

      .addCase(fixedItemSave.pending, handlePending)
      .addCase(fixedItemSave.fulfilled, handleFixedItemSaveFulfilled)
      .addCase(fixedItemSave.rejected, handleRejected)

      .addCase(conditionalItemOverseasSave.pending, handlePending)
      .addCase(conditionalItemOverseasSave.fulfilled, handleConditionalItemSaveFulfilled)
      .addCase(conditionalItemOverseasSave.rejected, handleRejected);
      
  },
});


export default priceListSlice.reducer;
